// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"342":"410996f0","521":"4bd4e732"}[chunkId] + ".js";
};